(() => {
  if (window.MintyEditorialEvents) return;
  const publish = (name, extra = {}) => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.analyticsProcessingAllowed?.() || window.Shopify?.designMode) return;
    const article = document.querySelector('[data-minty-story]');
    const updates = document.querySelector('[data-minty-updates]');
    try {
      Promise.resolve(window.Shopify?.analytics?.publish?.(`minty_editorial:${name}`, {
        story_id: article?.dataset.storyId || '',
        publication: article?.dataset.publication || updates?.dataset.publication || '',
        ...extra
      })).catch(() => {});
    } catch {}
  };
  window.MintyEditorialEvents = { publish };
  const acceptedSubmissions = () => {
    if (document.querySelector('[data-minty-newsletter-accepted]')) publish('newsletter_accepted');
    if (document.querySelector('[data-minty-comment-accepted]')) publish('comment_accepted');
  };
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) acceptedSubmissions();
    });
  } else acceptedSubmissions();
  document.querySelectorAll('[data-minty-related]').forEach(link => {
    link.addEventListener('click', () => publish('related_clicked', { target_story_id: link.dataset.storyTarget || '' }));
  });
  document.querySelectorAll('[data-minty-next-step] [data-minty-next-link]').forEach(link => {
    link.addEventListener('click', () => publish('next_step_clicked', {
      intent: link.dataset.mintyGoal || '',
      rank: link.dataset.mintyNextRank || '',
      destination: link.getAttribute('href') || ''
    }));
  });
  document.querySelectorAll('[data-minty-updates] form').forEach(form => {
    form.addEventListener('submit', () => publish('newsletter_form_submitted'));
  });
})();
